/** Session / Platform Settings entitlement for Order Service auto running numbers. */
export const AUTO_ORDER_SERVICE_NUMBER_ENTITLEMENT =
  "feature.logistics-workflow.auto_order_service_number";

/**
 * Resolve the Order Service No. shown in portals.
 * ON → allocated running number; OFF → Shipment Reference or "NEW".
 */
export function resolveOrderServiceDisplayNumber(opts: {
  autoNumbering: boolean;
  orderServiceNumber: string;
  shipmentReference?: string | null;
}): string {
  if (opts.autoNumbering) return opts.orderServiceNumber;
  const ref = opts.shipmentReference?.trim();
  return ref ? ref : "NEW";
}
